export default __webpack_public_path__ + "fb5ea040b306ce6c50998a3a6c6ccc92.svg";